import { render } from "./store-persons.vue?vue&type=template&id=1d702fc6"
import script from "./store-persons.vue?vue&type=script&lang=js"
export * from "./store-persons.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__